import axios from 'axios';
import CryptoJS from 'crypto-js';
import {BasicSelect} from 'vue-search-select';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import CONSTANT from './../../../../../shared/constants/constant';

export default {
  name: 'otherinformation',
  components: {
    BasicSelect,
    Treeselect
  },
  props: ['callFrom','ratebasis'],
  data() {
    return {
      MinCft: CONSTANT.MINCFT,
      voluMetricWtDivisorOther:'',
      voluMetricWtDivisor: '',
      uom: '',
      minChargeWeight:'',
      minBoxes:'',
      agreedweight: '',
      weightpresent: false,
      minweightflag:false,
      minboxesflag:false,
      applicableWeight: {
        selectedMaxMin:{
          text: 'Max',
          value: 'max'
        },
        selectedWeight1:{
          text: '',
          value: null
        },
        selectedWeight2:{
          text: 'Minimum Chargeable Weight',
          value: 'chargeableweight'
        }
      },
      billWeight:{
        selectedround:{
          text: 'Up',
          value: 'up'
        },
        selectedroundingfactor:"No Round Off",
        //roundFactor:1,
        selectedBillMaxMim : {
          text: 'Max',
          value: 'max'
        },
        selectedBillWeight1: {
          text: 'Applicable Weight',
          value: 'applicableweight'
        },
        selectedBillWeight2:{
          text: 'Minimum Chargeable Weight',
          value: 'chargeableweight'
        }
      },
      billableWeightRoundingFactorlist: [
        {label:"No Round Off", id:"No Round Off"},
        {label:"1 kg", id:"1"},
        {label:"5 kg", id:"5"},
        {label:"10 kg", id:"10"},
        {label:"20 kg", id:"20"},
      ],
      volweightlist: [
        {text:"4500 ", value:"4500"},
        {text:"20000 ", value:"20000"},
        {text:"Other ", value:"other"},
      ],
      applicableWeightRoundlist: [{text:"Up", value:"up"},
      {text:"Down", value:"down"}],

      applicableMaxMinList: [{text:"Min", value:"min"},
      {text:"Max", value:"max"}],

      ApplicableWeightList: [{text:"Physical Weight", value:"physicalweight"},
      {text:"Volumetric Weight", value:"volumetricweight"},
      {text:"Max (Physical Weight or Volumetric Weight)", value:"maxofphysicalorvolumetricweight"}],

      ApplicableWeightList2: [{text:"Physical Weight", value:"physicalweight"},
      {text:"Volumetric Weight", value:"volumetricweight"},
      {text:"Minimum Chargeable Weight", value:"chargeableweight"}],

      billMaxMinlist: [{text:"Min", value:"min"},
      {text:"Max", value:"max"}],

      billWeightList: [{text:"Minimum Chargeable Weight", value:"chargeableweight"},
      {text:"Applicable Weight", value:"applicableweight"}],

    }
  },
  computed: {},
  async mounted() {
    // this.setDimensionFields();
    // console.log(rateTemplateDetailsObject);
    this.isLoading = true;
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.useremail = userdetail.email;
    //this.getMinCFT();
    this.isLoading = false;
  },
  methods: {
    isNumber: function(evt) {
      this.minboxesflag = false;
      this.minweightflag = false;
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    isIntegerOnly: function(evt) {
      this.minboxesflag = false;
      this.minweightflag = false;
			evt = (evt) ? evt : window.event;
			var charCode = (evt.which) ? evt.which : evt.keyCode;
			if (charCode < 48 || charCode > 57) {
			  evt.preventDefault();;
			} else {
			  return true;
			}
		},
    setValues(rateTemplateDetailsObject) {
      //console.log(this.ApplicableWeightList.find(o => o.value == rateTemplateDetailsObject.applicablewt.round))
      if (rateTemplateDetailsObject && rateTemplateDetailsObject.id) {
        //this.voluMetricWtDivisor.text = rateTemplateDetailsObject.volumetricwtdivisor && this.volweightlist.find(o => o.value == rateTemplateDetailsObject.volumetricwtdivisor).text;
        //this.voluMetricWtDivisor.value = rateTemplateDetailsObject.volumetricwtdivisor && this.volweightlist.find(o => o.value == rateTemplateDetailsObject.volumetricwtdivisor).value;

        this.voluMetricWtDivisor = rateTemplateDetailsObject.volumetricwtdivisor;

        if(this.callFrom && this.callFrom.uom){
          let uom;
          if(this.callFrom.uom=='cm'){
            uom = "Centimeter";
          }else if(this.callFrom.uom=='in'){
            uom = "Inch";
          }
          this.uom = uom;
        }

        //this.voluMetricWtDivisorOther = rateTemplateDetailsObject.volumetricwtdivisorother;
        this.agreedweight = rateTemplateDetailsObject.agreedwtcft;
        this.minBoxes = rateTemplateDetailsObject.minimumboxes;
        this.minChargeWeight = rateTemplateDetailsObject.minimumchargeablewt;
        if(rateTemplateDetailsObject.applicablewt && Object.keys(rateTemplateDetailsObject.applicablewt).length != 0 && rateTemplateDetailsObject.applicablewt.constructor === Object){

          this.applicableWeight.selectedMaxMin.text = rateTemplateDetailsObject.applicablewt.maxMin && this.applicableMaxMinList.find(o => o.value == rateTemplateDetailsObject.applicablewt.maxMin).text;;
          this.applicableWeight.selectedMaxMin.value = rateTemplateDetailsObject.applicablewt.maxMin && this.applicableMaxMinList.find(o => o.value == rateTemplateDetailsObject.applicablewt.maxMin).value;;

          this.applicableWeight.selectedWeight1.text = rateTemplateDetailsObject.applicablewt.weight1 && this.ApplicableWeightList.find(o => o.value == rateTemplateDetailsObject.applicablewt.weight1).text;;
          this.applicableWeight.selectedWeight1.value = rateTemplateDetailsObject.applicablewt.weight1 && this.ApplicableWeightList.find(o => o.value == rateTemplateDetailsObject.applicablewt.weight1).value;;

          if (rateTemplateDetailsObject.applicablewt.weight2 == "chargeableweight") {
            this.applicableWeight.selectedWeight2.text = rateTemplateDetailsObject.applicablewt.weight2 && this.ApplicableWeightList2.find(o => o.value == rateTemplateDetailsObject.applicablewt.weight2).text;;
            this.applicableWeight.selectedWeight2.value = rateTemplateDetailsObject.applicablewt.weight2 && this.ApplicableWeightList2.find(o => o.value == rateTemplateDetailsObject.applicablewt.weight2).value;;
          }else{
            this.applicableWeight.selectedWeight2.text = "Minimum Chargeable Weight"
            this.applicableWeight.selectedWeight2.value = "chargeableweight"
          }
        }
        if(rateTemplateDetailsObject.billwt && Object.keys(rateTemplateDetailsObject.billwt).length != 0 && rateTemplateDetailsObject.billwt.constructor === Object) {
          this.billWeight.selectedBillMaxMim.text = rateTemplateDetailsObject.billwt.billMaxMim && this.billMaxMinlist.find(o => o.value == rateTemplateDetailsObject.billwt.billMaxMim).text;
          this.billWeight.selectedBillMaxMim.value = rateTemplateDetailsObject.billwt.billMaxMim && this.billMaxMinlist.find(o => o.value == rateTemplateDetailsObject.billwt.billMaxMim).value;

          this.billWeight.selectedBillWeight1.text = rateTemplateDetailsObject.billwt.billWeight1 && this.billWeightList.find(o => o.value == rateTemplateDetailsObject.billwt.billWeight1).text;;
          this.billWeight.selectedBillWeight1.value = rateTemplateDetailsObject.billwt.billWeight1 && this.billWeightList.find(o => o.value == rateTemplateDetailsObject.billwt.billWeight1).value;;
          if (rateTemplateDetailsObject.billwt.round) {
            this.billWeight.selectedround.text = rateTemplateDetailsObject.billwt.round && this.applicableWeightRoundlist.find(o => o.value == rateTemplateDetailsObject.billwt.round).text;
            this.billWeight.selectedround.value = rateTemplateDetailsObject.billwt.round && this.applicableWeightRoundlist.find(o => o.value == rateTemplateDetailsObject.billwt.round).value;
          }else{
            this.billWeight.selectedround.text = "Up"
            this.billWeight.selectedround.value = "up"
          }
          if (rateTemplateDetailsObject.billwt.roundFactor) {
            this.billWeight.selectedroundingfactor = rateTemplateDetailsObject.billwt.roundFactor
          }else{
            this.billWeight.selectedroundingfactor = "";
          }
        }
      }
    },
    selectApplicableWeightRound(data) {
      this.billWeight.selectedround.value = data.value;
      this.billWeight.selectedround.text = data.text;
    },
    selectBillableWeightRoundingFactor(data) {
      this.billWeight.selectedroundingfactor = data;
    },
    selectApplicableMaxMin(data) {
      this.applicableWeight.selectedMaxMin.value = data.value;
      this.applicableWeight.selectedMaxMin.text = data.text;
    },
    selectApplicableWeight1(data) {
      this.weightpresent = false;
      this.applicableWeight.selectedWeight1.value = data.value;
      this.applicableWeight.selectedWeight1.text = data.text;
    },
    selectApplicableWeight2(data) {
      this.applicableWeight.selectedWeight2.value = data.value;
      this.applicableWeight.selectedWeight2.text = data.text;
    },
    selectBillMaxMin(data) {
      this.billWeight.selectedBillMaxMim.value = data.value;
      this.billWeight.selectedBillMaxMim.text = data.text;
    },
    selectBillWeight1(data) {
      this.billWeight.selectedBillWeight1.value = data.value;
      this.billWeight.selectedBillWeight1.text = data.text;
    },
    selectBillWeight2(data) {
      this.billWeight.selectedBillWeight2.value = data.value;
      this.billWeight.selectedBillWeight2.text = data.text;
    },
    // setSelectVolWeightDivisor(data){
    //   this.voluMetricWtDivisor.text = data.text;
    //   this.voluMetricWtDivisor.value = data.value;
    //   if(this.voluMetricWtDivisorOther) {
    //     this.voluMetricWtDivisorOther = 0;
    //   }
    // },
    saveOnTabChange(){
      this.saveWeightDimension("saveAndNext",true)
    },
    saveWeightDimension(type, isTabChange){
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.ratebasis == 1 && (this.minChargeWeight == null || this.minChargeWeight =='')) {
            this.minweightflag = true;
            return false;
          }
          if (this.ratebasis == 2 && (this.minBoxes == null || this.minBoxes =='')) {
            this.minboxesflag = true;
            return false;
          }
          let submitobject = {};
          this.weightpresent = false;
          //submitobject.volumetricwtdivisor = this.voluMetricWtDivisor || null;
          //submitobject.volumetricwtdivisorother = this.voluMetricWtDivisorOther || (this.voluMetricWtDivisorOther == 0?0:null);
          submitobject.agreedwtcft = this.agreedweight || null;
          if (this.ratebasis == 1){
            if (this.applicableWeight.selectedWeight1.value == null || this.applicableWeight.selectedWeight1.value == "") {
              this.weightpresent = true;
              return false;
            }
            submitobject.minimumboxes = null
            submitobject.minimumchargeablewt = this.minChargeWeight || null;
            submitobject.applicablewt = {
            maxMin:this.applicableWeight.selectedMaxMin.value,
            weight1:this.applicableWeight.selectedWeight1.value,
            weight2:this.applicableWeight.selectedWeight2.value
          }
          submitobject.billwt = {
            round:this.billWeight.selectedround.value,
            roundFactor:this.billWeight.selectedroundingfactor,
            //billMaxMim:this.billWeight.selectedBillMaxMim.value,
            billWeight1:this.billWeight.selectedBillWeight1.value,
            //billWeight2:this.billWeight.selectedBillWeight2.value
          }
        }else{
          submitobject.minimumboxes = this.minBoxes || null;
          submitobject.minimumchargeablewt = null
          submitobject.applicablewt = {}
          submitobject.billwt = {}
        }
          if(isTabChange) {
            submitobject.isTabChange = isTabChange
          }
          if(type == "saveAndNext") {
            this.$emit("saveandnext", submitobject)
          } else {
            this.$emit("save", submitobject)
          }
				}
      }).catch(() => {
        console.log('errors exist')
      });
    },
    saveAndNextWeightDimension(){
      this.saveWeightDimension('saveAndNext')
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/ratetemplate/createratetemplate/weightdimension/weightdimension.component.js